<template>
  <ValidationObserver ref="formUser">
    <div class="row mt-2">
      <div class="col-md-6">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-2">
              <img src="~@/assets/images/unknown_person_64x64.png" width="64" />
            </div>
            <div class="col-md-5">
              <dt-input v-model="firstName" name="firstName" label="First Name" validate="required" tabindex="1" @keyup="userChanged" />
            </div>
            <div class="col-md-5">
              <dt-input v-model="lastName" name="lastName" label="Last Name" validate="required" tabindex="2" @keyup="userChanged" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <dt-input
                v-model="username"
                name="username"
                autocomplete="new-password"
                label="Username (email address)"
                validate="required"
                tabindex="3"
                v-if="isAdding"
                @blur="verifyUser"
                @keyup="userChanged"
              />
              <div class="mb-4 custom-username" v-else>
                <label class="mr-2">Username:</label>
                <input v-if="editingUsername" v-model="newUsername" />
                <span v-else>{{ username }}</span>
                <a href="#" @click="editUsername" v-show="!editingUsername">
                  <i class="fas fa-pencil-alt"></i>
                </a>
                <a href="#" @click="saveUsername" v-show="editingUsername">
                  <i class="fas fa-save"></i>
                </a>
              </div>
            </div>
            <div class="col-md-6">
              <label class="mr-2">Employee Id:</label>
                <input v-model="employeeId" disabled="disabled" />
              <!-- <dt-select
                v-model="contactType"
                name="contactType"
                label="Contact Type"
                :options="lookups['UserContactType']"
                validate="required"
                tabindex="4"
                v-show="cameFrom > 0"
                @change="userChanged"
              /> -->
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="cameFrom === 1">
          <div class="row mt-2">
            <div class="form-group col-md-6">
              <dt-select
                v-model="timezone"
                label="Time Zone"
                name="timezone"
                :options="lookups['TimeZone']"
                validate="required"
                tabindex="5"
                @change="userChanged"
              />
            </div>
            <div class="form-group col-md-6">
              <dt-select
                v-model="language"
                label="Language"
                name="language"
                :options="lookups['Language']"
                validate="required"
                tabindex="6"
                @change="userChanged"
              />
            </div>
          </div>
          <div class="row mt-2" v-if="isAdding">
            <div class="form-group col-md-6">
              <dt-input
                type="password"
                v-model="password"
                autocomplete="new-password"
                name="password"
                label="Password"
                validate="required"
                @blur="verifyPassword"
                tabindex="7"
                @keyup="userChanged"
              />
            </div>
            <div class="form-group col-md-6">
              <dt-input
                type="password"
                v-model="newpassword"
                autocomplete="new-password"
                name="newpassword"
                label="Password (again)"
                validate="required"
                @blur="verifyPassword"
                tabindex="8"
                @keyup="userChanged"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <dt-select v-model="role" name="role" label="User Role" :options="roles" validate="required" tabindex="9" @change="userChanged" />
            </div>
            <div class="form-group col-md-6">
              <dt-input
                v-model="laborRate"
                name="laborRate"
                label="Labor Rate (per hr)"
                type="number"
                validate="required"
                tabindex="10"
                @keyup="userChanged"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 pl-4">
              <input type="checkbox" v-model="isInactive" class="custom-checkbox" tabindex="11" @click="userChanged" />
              <span class="ml-1 mr-4">Inactive?</span>
              <input type="checkbox" v-model="receivesReport" class="custom-checkbox" tabindex="12" @click="userChanged" />
              <span class="ml-1 mr-4">Receives Reports</span>
              <input type="checkbox" v-model="receivesInvoice" class="custom-checkbox" tabindex="13" @click="userChanged" />
              <span class="ml-1 mr-4">Receives Invoices</span>
              <input type="checkbox" v-model="isDispatched" v-show="isTech" class="custom-checkbox" tabindex="14" @click="userChanged" />
              <span v-show="isTech" class="ml-1 mr-4">Is Dispatched</span>
              <!-- <input
                type="checkbox"
                v-model="receivesSms"
                class="custom-checkbox"
                tabindex="13"
              />
              <span class="ml-1">Receives SMS</span>
              <i
                class="fas fa-info-circle custom-info"
                title="Text Messages to be sent to mobile/cell number."
              ></i> -->
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 pl-4">
              <input type="checkbox" v-model="authEmail" class="custom-checkbox" tabindex="14" @click="userChanged" />
              <span class="ml-1 mr-4">Authorize Authority via Email</span>
              <input type="checkbox" v-model="authSms" class="custom-checkbox" tabindex="15" @click="userChanged" />
              <span class="ml-1 mr-4">Authorize Authority via SMS</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6 pl-4">
              <input type="checkbox" v-model="isChatInvitee" class="custom-checkbox" tabindex="16" @click="userChanged" />
              <span class="ml-1 mr-4">Add to all Chat Sessions upon Request Submission</span>
            </div>
            <div class="form-group col-6 pl-4">
              <input type="checkbox" v-model="isChatLookup" class="custom-checkbox" tabindex="16" @click="userChanged" />
              <span class="ml-1 mr-4">Include in Chat Lookup</span>
            </div>
          </div>
        </div>
        <!-- <div
          class="col-md-12"
          v-else
        >
          <file-upload
            ref="fileUploader"
            v-show="isReadyToUpload"
            :endpoint="endpoint"
            :path="path"
            :folder="folder"
            :userId="userId"
            @finished="finishedUploading"
          />
          <img
            v-show="!isReadyToUpload"
            :src="profilePhoto"
            class="img-responsive img-thumbnail custom-image"
            :alt="defaultPhoto"
          >
          <a
            href="#"
            @click="setReadyToUpload(true)"
            v-show="!isReadyToUpload"
          >upload new photo</a>
        </div> -->
      </div>
      <div class="col-md-6" v-if="!isAdding || (isAdding && isSaved)">
        <dt-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
        <div class="row p-3 custom-form" v-if="currentTab === 'Details'">
          <user-record :recordData="user" :showTitles="showTitles" :stacked="stacked" />
        </div>
        <div class="row p-3 custom-form" v-if="currentTab === 'Notifications'">
          <user-notifications @changed="userChanged" />
        </div>
        <div class="row p-3 custom-form" v-if="currentTab === 'Skills'">
          <user-skills ref="userSkills" @changed="userChanged" />
        </div>
        <div class="row p-3 custom-form" v-if="currentTab === 'Area'">
          <span>Future: Technician Postal Codes</span>
        </div>
      </div>
      <div class="col-md-6" v-else-if="isVerified">
        <button class="btn btn-primary" @click="save" tabindex="12">Add New User</button>
      </div>
    </div>
  </ValidationObserver>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import globals from '@/plugins/globals'
import DtInput from '@/components/utilities/form/dt-input'
import DtSelect from '@/components/utilities/form/dt-select'
import DtTextarea from '@/components/utilities/form/dt-textarea'
import UserInfo from '@/components/users/forms/user-info'
import UserRecord from '@/components/users/listings/user-record'
import DtTabs from '@/components/utilities/form/dt-tabs'
import UserSkills from '@/components/users/forms/user-skills'
import UserNotifications from '@/components/users/forms/user-notifications'
// import FileUpload from '@/components/utilities/form/dt-uploader'
export default {
  name: 'user-profile',
  components: {
    DtInput,
    DtSelect,
    DtTextarea,
    UserInfo,
    UserRecord,
    DtTabs,
    UserSkills,
    UserNotifications
    // FileUpload
  },
  props: {
    cameFrom: {
      type: Number,
      default: 0
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSaved: false,
      showTitles: true,
      stacked: true,
      endpoint: '/file/upload',
      path: '/images/',
      defaultPhoto: null,
      readyToUpload: false,
      newpassword: '',
      isAdding: false,
      isVerified: false,
      newUsername: '',
      editingUsername: false,
      currentTab: 'Details'
    }
  },
  mounted() {
    this.isAdding = this.isAdd
    this.isVerified = !this.isAdd
    this.newUsername = ''
    this.editingUsername = false
  },
  computed: {
    ...mapGetters('lookups', ['lookups']),
    ...mapGetters('users', ['user', 'roles', 'userNotifications']),
    tabs() {
      let _tabs = ['Details', 'Notifications']
      if (this.isTech) {
        _tabs.push('Skills')
        _tabs.push('Area')
      }
      return _tabs
    },
    firstName: {
      get() {
        return this.user !== null ? this.user.firstName : ''
      },
      set(value) {
        this.updateUser({
          name: 'firstName',
          value: value
        })
      }
    },
    lastName: {
      get() {
        return this.user !== null ? this.user.lastName : ''
      },
      set(value) {
        this.updateUser({
          name: 'lastName',
          value: value
        })
      }
    },
    timezone: {
      get() {
        return this.user !== null ? this.user.timezone : ''
      },
      set(value) {
        this.updateUser({
          name: 'timezone',
          value: value
        })
      }
    },
    language: {
      get() {
        return this.user !== null ? this.user.language : ''
      },
      set(value) {
        this.updateUser({
          name: 'language',
          value: value
        })
      }
    },
    username: {
      get() {
        return this.user !== null ? this.user.username : ''
      },
      set(value) {
        this.updateUser({
          name: 'username',
          value: value
        })
      }
    },
    employeeId: {
      get() {
        return this.user !== null ? (this.user.employeeId ? this.user.employeeId : '') : ''
      }
    },
    password: {
      get() {
        return this.user !== null ? this.user.password : ''
      },
      set(value) {
        this.updateUser({
          name: 'password',
          value: value
        })
      }
    },
    contactType: {
      get() {
        return this.user !== null ? this.user.contactType : 0
      },
      set(value) {
        this.updateUser({
          name: 'contactType',
          value: value
        })
      }
    },
    role: {
      get() {
        let _role = 0
        if (this.user !== null) {
          if (this.user.roles !== null) {
            if (this.user.roles.indexOf(',') > 0) {
              var roles = this.user.roles.split(',')
              _role = roles[0]
            } else {
              _role = this.user.roles
            }
          }
        }
        return _role
      },
      set(value) {
        this.updateUser({
          name: 'role',
          value: value
        })
      }
    },
    laborRate: {
      get() {
        return this.user !== null ? this.user.laborRate : ''
      },
      set(value) {
        if (globals.isNumeric(value)) {
          this.updateUser({
            name: 'laborRate',
            value: value
          })
        }
      }
    },
    isInactive: {
      get() {
        return this.user !== null ? this.user.isInactive : false
      },
      set(value) {
        this.updateUser({
          name: 'isInactive',
          value: value
        })
      }
    },
    receivesReport: {
      get() {
        return this.user !== null ? this.user.receivesReport : false
      },
      set(value) {
        this.updateUser({
          name: 'receivesReport',
          value: value
        })
      }
    },
    receivesInvoice: {
      get() {
        return this.user !== null ? this.user.receivesInvoice : false
      },
      set(value) {
        this.updateUser({
          name: 'receivesInvoice',
          value: value
        })
      }
    },
    receivesSms: {
      get() {
        return this.user !== null ? this.user.receivesSms : false
      },
      set(value) {
        this.updateUser({
          name: 'receivesSms',
          value: value
        })
      }
    },
    isDispatched: {
      get() {
        return this.user !== null ? this.user.isDispatched : false
      },
      set(value) {
        this.updateUser({
          name: 'isDispatched',
          value: value
        })
      }
    },
    isChatInvitee: {
      get() {
        return this.user !== null ? this.user.isChatInvitee : false
      },
      set(value) {
        this.updateUser({
          name: 'isChatInvitee',
          value: value
        })
      }
    },
    isChatLookup: {
      get() {
        return this.user !== null ? this.user.isChatLookup : false
      },
      set(value) {
        this.updateUser({
          name: 'isChatLookup',
          value: value
        })
      }
    },
    authEmail: {
      get() {
        return this.user !== null ? this.user.authEmail : false
      },
      set(value) {
        this.updateUser({
          name: 'authEmail',
          value: value
        })
      }
    },
    authSms: {
      get() {
        return this.user !== null ? this.user.authSms : false
      },
      set(value) {
        this.updateUser({
          name: 'authSms',
          value: value
        })
      }
    },
    email: {
      get() {
        return this.user !== null ? this.user.username : ''
      }
    },
    folder: {
      get() {
        return this.user !== null ? this.user.firm + '/' : ''
      }
    },
    userId: {
      get() {
        return this.user !== null ? this.user.userId : ''
      }
    },
    isReadyToUpload: {
      get() {
        let _showIt = true
        if (this.user !== null) {
          if (this.user.imagePhotoPath !== '') {
            _showIt = false
          }
        }
        if (_showIt === false) {
          if (this.readyToUpload) {
            _showIt = true
          }
        }
        return _showIt
      }
    },
    profilePhoto: {
      get() {
        return this.user !== null ? this.user.imagePhotoPath : ''
      }
    },
    isTech() {
      let _is = false
      if (this.user) {
        if (this.user.roles === '14') {
          _is = true
        }
      }
      return _is
    }
  },
  methods: {
    ...mapActions('users', ['getUser', 'saveUser', 'updateUser', 'verifyUsername', 'getUserNotifications', 'saveUserNotifications']),
    setReadyToUpload(value) {
      this.readyToUpload = value
    },
    close() {
      this.currentTab = 'Detail'
      this.$emit('closing')
    },
    async showTab(value) {
      if (value === 'Details' && this.currentTab === 'Skills') {
        let skills = this.$refs.userSkills.getSkills()
        if (skills !== '') {
          this.updateUser({
            name: 'skills',
            value: skills
          })
        }
      } else if (value === 'Notifications') {
        if (this.userNotifications.length === 0) {
          await this.getUserNotifications(this.user.user)
        }
      }
      this.currentTab = value
    },
    userChanged() {
      this.$emit('changed')
    },
    async finishedUploading() {
      await this.getUser(this.user.username)
      this.$refs.fileUploader.reset()
      this.readyToUpload = false
    },
    editUsername() {
      this.newUsername = this.username
      this.editingUsername = true
    },
    saveUsername() {
      this.username = this.newUsername
      this.editingUsername = false
      this.save()
    },
    validatePassword() {
      let valid = true
      this.reason = ''
      if (this.isLoading === false && this.password !== '') {
        let strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})')
        valid = strongRegex.test(this.password)
        if (valid === false) {
          this.reason =
            "Password doesn't meet minimum strength of special characters (!@#$%^&*), lower case (a-z), upper case (A-Z) and numbers (0-9), and at least 8 characters in length."
        }
      }
      return valid
    },
    verifyPassword() {
      if (!this.validatePassword()) {
        alert(this.reason)
      }
    },
    async verifyUser() {
      this.isVerified = false
      let data = await this.verifyUsername(this.user.username)
      if (data.isThere) {
        alert('Username already exists, please try another.')
      } else {
        this.isVerified = true
      }
    },
    async saveNotifications() {
      let changed = false
      if (this.userNotifications) {
        let notifications = []
        this.userNotifications.forEach(element => {
          if (element.changed) {
            notifications.push({
              userNotification: element.userNotification,
              user: element.user,
              notificationType: element.notificationType,
              isNotification: element.isNotification === 1
            })
            changed = true
          }
        })
        if (changed) {
          console.log('Save User Notifications', notifications)
          await this.saveUserNotifications(notifications)
          await this.getUserNotifications(this.user.user)
        }
      }
    },
    async save() {
      let notice = 'Please supply fill all fields.'
      this.$refs.formUser.validate().then(async success => {
        let valid = true
        if (success) {
          if (this.user.timezone === 0) {
            valid = false
            notice += '  Please supply a Timezone.'
          }
          if (this.user.language === 0) {
            valid = false
            notice += '  Please supply a Language.'
          }
          if (this.isTech) {
            if (this.$refs.userSkills) {
              let skills = this.$refs.userSkills.getSkills()
              let proceed = true
              if (!skills) {
                proceed = false
              } else {
                if (skills.length === 0) {
                  proceed = false
                }
              }
              if (proceed === false) {
                valid = false
                notice += ' Please provide Skills'
              } else {
                this.updateUser({
                  name: 'skillDetail',
                  value: skills
                })
              }
            }
          }
          console.log('Saving the User Profile', this.user)
          if (valid) {
            await this.saveUser(this.user)
            this.isSaved = true
            if (this.isAdding) {
              console.log('Refreshing User after Adding')
              await this.getUser(this.user.username)
            }
            this.$emit('saved', this.isSaved)
            this.isAdding = false
          } else {
            alert(notice)
          }
        } else {
          alert(notice)
        }
      })
      await this.saveNotifications()
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-image {
  width: 300px;
  height: 300px;
}
.custom-username {
  position: relative;
  a {
    float: right;
    color: #2c6ffe;
  }
}
.custom-info {
  color: #2c6ffe;
  cursor: pointer;
}

.custom-form {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 500px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/users/forms/user-profile.vue